import type { ComponentProps } from 'react';

export interface ThemeSwitchProps extends ComponentProps<'div'> {
  mode?: 'light-dark' | 'light-dark-system';
}

/** @deprecated Dark mode is no longer supported. */
export function ThemeSwitch(_props: ThemeSwitchProps) {
  return null;
}
